export const hosts = {
  FAKE: 0,
  JIRA_CONNECT: 1,
  STANDALONE: 2,
  JIRA_SERVER: 3
}
